<template functional>
  <div>
    {{ props.error.message || props.error }}
  </div>
</template>

<script>
export default {
  props: {
    error: {
      type: [String, Object],
      default: false,
    },
  },
}
</script>
